<template>
  <div>
    <!--    <img src="@/assets/damage.jpg" @click="showDialogImg = true" v-if="!imgList"/>-->
    <div class="icon-box">
      <img style="width: 50px;height: 50px" :src="firstIcon" @click="showDialogImg = true" v-if="imgList"/>
      <el-dialog fullscreen append-to-body :visible.sync="showDialogImg" :before-close="closeImage" width="70%" class="block-box">
        <el-carousel>
          <el-carousel-item v-for="item in this.imgList" :key="item">
            <img
              :src="imgUrlFormate(item)"
              alt=""
              class="show-img"
            />
          </el-carousel-item>
        </el-carousel>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import {baseURL} from "@/utils/getawayModule";
export default {
  name: 'iconImg',
  props: ['icon'],
  data() {
    return {
      showDialogImg: false,
      firstIcon: '',
      imgList: [],
    }
  },
  watch: {
    icon(val) {
      if (val) {
        this.imgList = val.split(",");
        this.firstIcon = this.getFirstIcon()
      } else {
        this.imgList = [];
        this.firstIcon = '';
      }
    }
  },
  created() {
    if (this.icon) {
      this.imgList = this.icon.split(",");
      this.firstIcon = this.getFirstIcon()
    }
  },
  methods: {
    // 获取第一张icon
    getFirstIcon() {
      if (this.imgList && this.imgList.length > 0) {
        return `${baseURL.userApi}/file/${this.imgList[0]}/download`;
      }

    },
    closeImage() {
      this.showDialogImg = false
    }
  }
}
</script>
<style lang="less" scoped>
/deep/ .el-dialog {
  .el-dialog__body {
    height: 90%;
    .el-carousel__container {
      height: 95%;
    }
    .el-carousel {
      height: 100%;
    }
    img {
      display: block;
      margin: 0 auto;
      height: 100%;
    }
  }
}

/deep/ .el-dialog.is-fullscreen {
  background-color: rgba(0,0,0,0.3);
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
  color: #ffffff;
}
</style>
